/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useQuery } from 'react-query';
import { Loader, Position } from '@locus-taxy/neo-ui';

import { personnelMaster as personnelApi } from 'common/middleware/api';
import { ApiStatusEnum } from 'common/enums/API';
import useClientId from 'common/hooks/useClientId';
import { MasterPersonnel } from 'common/models/internal/MasterPersonnel';
import { useToast, ToastTypes } from 'common/components/core/toast';

import {
    type PersonnelTypeEnumType,
    PersonnelTypeEnum
} from 'common/enums/PersonnelEnums';

type Props = {
    personnelId: string,
    render: (type: PersonnelTypeEnumType) => React.Node
};

const usePersonnelMasterQuery = ({ id, clientId }) => {
    return useQuery<MasterPersonnel>({
        queryKey: ['entities', 'personnel', id],
        queryFn: async () => {
            const personnel = await personnelApi.fetch({
                clientId,
                personnelId: id
            });

            return MasterPersonnel.fromJS(personnel);
        }
    });
};

const PersonnelTypeQuerySelector = ({
    render,
    personnelId
}: Props): React.Node => {
    const clientId = useClientId();
    const { showToast } = useToast();

    const personnelQuery = usePersonnelMasterQuery({
        id: personnelId,
        clientId
    });

    if (personnelQuery.status === ApiStatusEnum.Loading) {
        return (
            <Position position="absolute" left={0} top={0} right={0} bottom={0}>
                <Loader
                    width="100%"
                    height="100%"
                    size="large"
                    color="blue.500"
                />
            </Position>
        );
    }

    if (personnelQuery.status === ApiStatusEnum.Error) {
        return showToast({
            message: personnelQuery.error.message,
            type: ToastTypes.Error
        });
    }

    return render(
        personnelQuery.data.personnelType || PersonnelTypeEnum.CLIENT
    );
};

export default PersonnelTypeQuerySelector;
